import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import {
  formatCurrency as sharedFormatCurrency,
  formatDate as sharedFormatDate,
  formatRelative as sharedFormatRelative,
} from '@trinco/shared';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number, currency = 'CAD', locale = 'en-US') {
  return sharedFormatCurrency(amount, currency, locale);
}

export function formatDate(date: string, locale = 'en-US') {
  return sharedFormatDate(date, locale);
}

export function formatRelative(date: string) {
  return sharedFormatRelative(date);
}
